import {
  isWandbArtifactRef,
  isWeaveObjectRef,
  ObjectRef,
} from '@wandb/weave/react';
import React, {FC} from 'react';

import {SmallArtifactRef} from './SmallArtifactRef';
import {SmallWeaveRef} from './SmallWeaveRef';

export const SmallRef: FC<{
  objRef: ObjectRef;
  iconOnly?: boolean;
  noLink?: boolean;
  displayName?: string;
}> = ({objRef, ...props}) => {
  if (isWeaveObjectRef(objRef)) {
    return <SmallWeaveRef objRef={objRef} {...props} />;
  }
  if (isWandbArtifactRef(objRef)) {
    return <SmallArtifactRef objRef={objRef} {...props} />;
  }
  return <div>[Error: non wandb ref]</div>;
};
